import {
  type GlMapCreateOperation,
  OpenAPI as ConfigurationOpenAPI,
} from '@festina/configuration-general-types/configuration'
import { useMutation } from '@tanstack/react-query'

import { fetchFromService } from '../fetchFromService'

type TriggerProps = {
  glMapCreateOperation: GlMapCreateOperation
}

/**
 * Converts a GL-map create operation back into the Excel document it was authored in.
 *
 * The service answers with the document bytes, which the generated client decodes as
 * text and thereby corrupts, so the request is issued manually.
 */
export const useMutateConvertGlMapCreateOperationToExcel = () =>
  useMutation({
    mutationFn: async ({ glMapCreateOperation }: TriggerProps) => {
      const response = await fetchFromService({
        serviceConfig: ConfigurationOpenAPI,
        serviceName: 'configuration',
        path: '/conversion/glmap/convert-to-format',
        method: 'POST',
        body: JSON.stringify(glMapCreateOperation),
        headers: { 'Content-Type': 'application/json' },
        errorMessage: 'Failed to convert the GL-map create operation to Excel',
      })

      return await response.blob()
    },
  })
